// Deterministic, fictional data for the illustrative workspace mockup and sample outlook (not a real ticker or signal).
const rng = (seed) => () => {
  seed = (seed * 16807) % 2147483647;
  return (seed - 1) / 2147483646;
};

const buildCandles = (n = 60, seed = 4242) => {
  const r = rng(seed);
  const out = [];
  let prev = 92;
  for (let i = 0; i < n; i += 1) {
    const drift = i < 22 ? -0.08 : 0.32;
    const open = prev + (r() - 0.5) * 0.8;
    const close = open + drift + (r() - 0.48) * 2.2;
    const high = Math.max(open, close) + r() * 1.1;
    const low = Math.min(open, close) - r() * 1.1;
    out.push({ open, high, low, close, volume: 0.8 + r() * 0.6 + (i > n - 6 ? 0.35 : 0) });
    prev = close;
  }
  return out;
};

const ema = (vals, p) => {
  const k = 2 / (p + 1);
  return vals.reduce((acc, v, i) => [...acc, i === 0 ? v : v * k + acc[i - 1] * (1 - k)], []);
};

const rsi = (closes, p = 14) => {
  let g = 0;
  let l = 0;
  for (let i = closes.length - p; i < closes.length; i += 1) {
    const d = closes[i] - closes[i - 1];
    if (d > 0) g += d; else l -= d;
  }
  return 100 - 100 / (1 + g / (l || 1e-9));
};

const atr = (bars, p = 14) => {
  const trs = bars.slice(-p).map((b, i, arr) => {
    const pc = (arr[i - 1] || bars[bars.length - p - 1]).close;
    return Math.max(b.high - b.low, Math.abs(b.high - pc), Math.abs(b.low - pc));
  });
  return trs.reduce((a, b) => a + b, 0) / p;
};

const candles = buildCandles();
const closes = candles.map((c) => c.close);
const ema21 = ema(closes, 21);
const ema50 = ema(closes, 50);
const last = closes[closes.length - 1];
const a = atr(candles);
const H = 5;
const target = last + a * Math.sqrt(H) * 1.5;
const stop = last - a * 1.5;
const vols = candles.map((c) => c.volume);
const relVol = (vols.slice(-5).reduce((x, y) => x + y, 0) / 5) / (vols.slice(-20).reduce((x, y) => x + y, 0) / 20);

export const SAMPLE = {
  ticker: 'EXMPL',
  name: 'Example Corp (fictional)',
  horizon: '1 week',
  strategy: 'Momentum',
  score: 68,
  direction: 'Bullish',
  probability: 58,
  candles,
  ema21,
  ema50,
  entry: last,
  target,
  stop,
  atr: a,
  rr: (target - last) / (last - stop),
  rsi: rsi(closes),
  roc20: (last / closes[closes.length - 21] - 1) * 100,
  vsEma50: (last / ema50[ema50.length - 1] - 1) * 100,
  relVol,
  components: [
    { label: 'Momentum', value: 71 },
    { label: 'Trend', value: 80 },
    { label: 'Volume', value: 62 },
    { label: 'Volatility', value: 58 },
  ],
  scenarios: [
    { label: 'Bull', share: 34, note: 'Breaks recent high, runs toward target' },
    { label: 'Base', share: 46, note: 'Holds above EMA 21, drifts higher' },
    { label: 'Bear', share: 20, note: 'Loses EMA 50, tests the stop' },
  ],
};

export const usd = (v) => `$${v.toFixed(2)}`;
export const pct = (v, d = 1) => `${v >= 0 ? '+' : ''}${v.toFixed(d)}%`;
